import {Controller} from "stimulus"

export default class extends Controller {
    connect() {
        this.handleContactSelected = this.handleContactSelected.bind(this)
        this.element.addEventListener("contact-select-v2:added", this.handleContactSelected)
    }

    disconnect() {
        this.element.removeEventListener("contact-select-v2:added", this.handleContactSelected)
    }

    showContactForm(e) {
        e.preventDefault()
        const selectWrapper = this.selectWrapper()
        if (selectWrapper) {
            selectWrapper.classList.add("hidden")
        }
        const addButton = this.addButton()
        if (addButton) {
            addButton.classList.add("hidden")
        }
        const contactFieldset = this.contactFieldset()
        if (contactFieldset) {
            contactFieldset.classList.remove("hidden")
        }
        this.updatePersonServedFromNames()
    }

    cancelContactForm(e) {
        e.preventDefault()
        const contactFieldset = this.contactFieldset()
        if (contactFieldset) {
            contactFieldset.classList.add("hidden")
        }
        const selectWrapper = this.selectWrapper()
        if (selectWrapper) {
            selectWrapper.classList.remove("hidden")
        }
        const addButton = this.addButton()
        if (addButton) {
            addButton.classList.remove("hidden")
        }
        this.clearContactFieldset()
    }

    updatePersonServedFromNames() {
        const contactFieldset = this.contactFieldset()
        const personServedInput = this.personServedInput()
        if (!personServedInput || !contactFieldset) {
            return
        }
        if (contactFieldset.classList.contains("hidden")) {
            return
        }
        const name = [this.firstNameValue(), this.lastNameValue()].filter((value) => value.length > 0).join(" ")
        if (name.length === 0) {
            return
        }
        this.setPersonServed(name)
    }

    handleContactSelected(event) {
        if (!event.detail || !event.detail.contactLabel) {
            return
        }
        this.setPersonServed(event.detail.contactLabel)
    }

    setPersonServed(value) {
        const personServedInput = this.personServedInput()
        if (!personServedInput) {
            return
        }
        if (personServedInput.tagName === "SELECT") {
            let option = Array.from(personServedInput.options).find((opt) => opt.value === value)
            if (!option) {
                option = new Option(value, value, true, true)
                personServedInput.add(option)
            }
            personServedInput.value = value
            return
        }
        personServedInput.value = value
    }

    firstNameValue() {
        const input = this.firstNameInput()
        return input ? input.value.trim() : ""
    }

    lastNameValue() {
        const input = this.lastNameInput()
        return input ? input.value.trim() : ""
    }

    selectWrapper() {
        return this.element.querySelector("[data-person-served-select-wrapper]")
    }

    personServedInput() {
        return this.element.querySelector("[data-person-served-select]")
    }

    addButton() {
        return this.element.querySelector("[data-person-served-add-button]")
    }

    contactFieldset() {
        return this.element.querySelector("[data-person-served-contact-fieldset]")
    }

    firstNameInput() {
        return this.element.querySelector("[data-person-served-first-name]")
    }

    lastNameInput() {
        return this.element.querySelector("[data-person-served-last-name]")
    }

    clearContactFieldset() {
        const contactFieldset = this.contactFieldset()
        if (!contactFieldset) {
            return
        }
        const inputs = contactFieldset.querySelectorAll("input, select, textarea")
        inputs.forEach((input) => {
            if (input.type === "checkbox" || input.type === "radio") {
                input.checked = false
            } else if (input.tagName === "SELECT") {
                input.value = ""
            } else {
                input.value = ""
            }
        })
        const selectedContacts = contactFieldset.querySelector(".selected-contacts")
        if (selectedContacts) {
            selectedContacts.classList.add("hidden")
            selectedContacts.innerHTML = ""
        }
        const searchResults = contactFieldset.querySelectorAll(".contact-search-results")
        searchResults.forEach((results) => {
            results.classList.add("hidden")
            results.innerHTML = ""
        })
        const contactPopup = contactFieldset.querySelector(".contact-method-select-popup")
        if (contactPopup) {
            contactPopup.classList.remove("editing")
        }
        const contactSelectionArea = contactFieldset.querySelector(".contact-method-selection-area")
        if (contactSelectionArea) {
            contactSelectionArea.innerHTML = ""
        }
    }
}
